import React, { useState } from "react";
import styled from "styled-components";
import {
    Button,
    LottieLoadingIndicator,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModal,
    StandardModalFormGroup,
    StandardModalSection,
    StandardModalSectionTitle,
    Toast,
    FormField
} from "src/components";
import { updateCustomBodyAndMindName } from "../../api";
import { DefaultBodyAndMindFeatureName } from "../../BodyAndMindList";

const StyledTitleInput = styled(FormField)`
    border: 1px solid #8291b2;
    border-radius: 12px;
    text-align: left;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #000;
    width: 364px;
    max-width: 100%;
    height: 50px;
    box-shadow: none;

    ::placeholder {
        text-align: left;
        color: #808080;
        font-family: Manrope, Helvetica, sans-serif;
    }
`;

export default function ChangeNameDialog(props) {
    const { hideShowNameChangeDialog, currentFeatureName, setCustomBodyAndMindName } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [customName, setCustomName] = useState(currentFeatureName);

    const onSubmit = async () => {
        setIsLoading(true);
        try {
            const response = await updateCustomBodyAndMindName(customName);
            setCustomBodyAndMindName(response.customName || DefaultBodyAndMindFeatureName);
            hideShowNameChangeDialog();
        } catch (error) {
            console.log(error);
            Toast.error(error.getApiErrorDetails().message);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <StandardModalSection>
                <LottieLoadingIndicator/>
            </StandardModalSection>
        );
    }

    return (
        <StandardModal
            open={true}
            onClose={hideShowNameChangeDialog}
            title="Change Body & Mind Feature Name"
            description="Rename the Body & Mind feature in the Me Business app and portal to better align with your business or content purpose."
            widthMode="medium"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        type="button"
                        onClick={() => hideShowNameChangeDialog()}
                        size="0.875rem"
                        border="1px solid #000"
                        color="#000"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        backgroundColor="#171A22"
                        border="1px solid #171A22"
                        color="#fff"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                        onClick={() => onSubmit()}
                    >
                        Save
                    </Button>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalFormGroup>
                    <StandardModalSectionTitle>Set a Custom Name (Optional)</StandardModalSectionTitle>
                    <StandardModalDescription>
                    Enter a new name for this feature. If left blank, it will appear as ‘Body & Mind’.
                    </StandardModalDescription>
                    <StyledTitleInput
                        name="CustomBodyAndMindName"
                        value={customName}
                        placeholder="e.g. Wellbeing Hub"
                        onChange={(e) => setCustomName(e.target.value || "")}
                    />
                </StandardModalFormGroup>
            </StandardModalSection>
        </StandardModal>
    );
}
